import React, { Component } from 'react';
import PageLoader from '../components/global/PageLoader';

class RegisterReadyToBegin extends Component {
	render() {
		let { continueRegistration, groupPoster, welcomeDisplay } = this.props;

		return (
			<div>
				<div className={"pilotly-register-form col s7 p-0 pt-40 pb-10" + (groupPoster ? "" : " m-auto pull-none")}>
					<h1 className="begin-title">{welcomeDisplay.title}</h1>
					<p className="begin-message mb-30">{welcomeDisplay.message}</p>

					<button className={"waves-effect waves-light btn register-field-submit begin-registration text-transform-none" + (continueRegistration ? "" : " form-lock")}
						onClick={continueRegistration ?
							() => this.props.enableRegistration()
							:
							null}>
						<PageLoader loading={!continueRegistration} small={true} />

						{welcomeDisplay.ctaButton}
					</button>
				</div>

				{groupPoster ?
					<div className="pilotly-register-form group-poster col s5 pl-10">
						<img src={groupPoster} alt="Poster" />
					</div>
					:
					""
				}
			</div>
		);
	}
}

export default RegisterReadyToBegin;


// WEBPACK FOOTER //
// ./src/pages/RegisterReadyToBegin.js